import { render, staticRenderFns } from "./SerSalaoSpa.vue?vue&type=template&id=42e2edc0&"
import script from "./SerSalaoSpa.vue?vue&type=script&lang=js&"
export * from "./SerSalaoSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports